import React from 'react';
import Drawer from 'rc-drawer';
import 'rc-drawer/assets/index.css';

import MediaQuery from 'react-responsive';
import {matchPath, useLocation, useNavigate} from 'react-router';
import {Button, Dropdown, Menu, MenuProps, Modal, Switch, Tooltip} from 'antd';

import {Link} from 'react-router-dom';
import {ExtendedTokenParsed} from '../types/Token';

import moment from 'moment';

import parse from 'url-parse';

import HSearch from './Search';
import DocumentIcon from '../components/icons/DocumentIcon';

//import RegistrarInfo from '../components/Views/RegistrarInfo.tsx.old';
import {TestDescroptionModal} from '../components/Views/TestDescriptionModal';
import Flex from '../components/StyledComponents/Flex';
import StyledLink from '../components/StyledComponents/StyledLink';
// import get from 'lodash/get';
//import {checkIsRegistry, hasRole} from '../utils/token/TokenUtils.ts.old';
import {Actions, Subjects} from '../configuration/permission/ability';
import Keycloak from "keycloak-js";
import {hasRole, isNullOrUndefined} from "../utils";
import {useTranslation} from "@nic-react-i18n/core";
import {useKeycloak} from "@nic-react/auth";
import {Can} from "../context/Authorization";
import RegistrarInfo from "../components/Views/RegistrarInfo";

export interface HeaderProps  {
}

type HeaderType =  HeaderProps

const docConf = 'DocumentConfiguration';

type MenuMode = 'vertical' | 'horizontal' | 'inline'

const Header: React.FC<HeaderType> = (props) => {

    const {t, locale, updateLocale} = useTranslation()
    const {keycloak} = useKeycloak()

    const location = useLocation()
    const navigate = useNavigate()
    const [showDocuments, setShowDocuments] = React.useState(false)
    const [testVersion, setTestVersion] = React.useState('1.0')
    const [testType, setTestType] = React.useState('registrar')
    const [openMenu, setOpenMenu] = React.useState(false)
    const [openInfo, setOpenInfo] = React.useState(false)



    const renderLogo = (size: string) => {
        return (

            <div
                className={'arp-logo'}
                style={{
                    fontSize: size,
                    flexGrow: 0
                }}
            >
                <Link style={{color: 'black'}} to={'/home'}>
                    ARP <i className="fal fa-check-square logo-icon-color"/>
                </Link>
            </div>

        );
    }

    const renderDocumentModal = () => {
        return (
            <TestDescroptionModal
                showDocuments={showDocuments}
                onCancel={() => {
                    setShowDocuments(false)
                }}
                testType={testType}
                testVersion={testVersion}
            />
        );
    }

    const searchRegistrar = (value: string): void => {
        if (value.length >= 5 && value.toUpperCase().endsWith('-REG')) {
            setOpenMenu(false)
            navigate('/requests?registrar=' + value);
        }
    }

    const
        renderSmallDisplayHeader = (): React.ReactElement<any> => {

        let isRegistry: boolean = keycloak.realm === 'registry'

        if (!isRegistry) {
            return renderLargeDisplayHeader('4vw');
        } else {
            // let isDefault: boolean = (locale === 'it');
            let url = parse(location.pathname);
            let matchCalendar = matchPath('/bookings/calendar/:period/:year?/:month?/:day?', url.pathname);
            let matchRequest = matchPath('/requests', url.pathname);

            const today = moment();
            const week = today.week();
            const year = today.year();

            return (
                <Flex
                    direction={'row'}
                    justify={'space-around'}
                    align={'center'}
                    style={{
                        height: '10vh',
                        width: '100vw',
                        backgroundColor: 'white',
                    }}
                >

                    <Drawer
                        getContainer={null}
                        style={{left: 0}}
                        open={openMenu}
                        onHandleClick={() => {
                            setOpenMenu(!openMenu)
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                width: '80vw',
                                height: '100vh'
                            }}

                        >
                            <div>
                                <div style={{textAlign: 'center', marginTop: '4vh'}}>
                                    {renderLogo('4vw')}
                                </div>
                                <Menu>
                                    <Menu.Item>
                                        {renderSearch()}
                                    </Menu.Item>
                                </Menu>
                                <Menu mode={'inline'} onSelect={() => {setOpenMenu( false); }}>
                                    <Menu.Item>
                                        {renderMenuItem('/requests', 'header.menu.Requests', matchRequest)}
                                    </Menu.Item>
                                    <Can I={Actions.VIEW} a={Subjects.CALENDAR}>
                                        <Menu.Item>
                                            {renderMenuItem(
                                                `/bookings/calendar/week/${year}/${week}`,
                                                'header.menu.Calendar', matchCalendar)}
                                        </Menu.Item>
                                    </Can>
                                </Menu>
                                {renderDocumentList('inline')}
                                {renderLanguageSwitch()}
                            </div>
                        </div>
                    </Drawer>

                    <Flex
                        direction={'row'}
                        align={'center'}
                        justify={'space-between'}
                        style={{
                            width: '90vw',
                            backgroundColor: 'white',
                        }}
                    >

                        {renderLogo('3.5vw')}

                        <Flex
                            direction={'row'}
                            justify={'flex-end'}
                            align={'center'}
                            style={{
                                fontSize: '2.5vw',
                                flexGrow: 1
                            }}
                        >

                            {renderUserMenu(false)}
                        </Flex>
                    </Flex>
                </Flex>
            );
        }
    }

    const renderSearch = () => {


        let item = <></>;
//console.log('RenderSearch: HasRole? ', hasRole(keycloak, 'user'))


        if (hasRole(keycloak, 'user')) {
            //console.log('RenderSearch: HasRole++? ', hasRole(keycloak, 'user'))
            return  (
                <div>
                    <HSearch
                        placeholder={t('header.search')}
                        onSearch={(value: string): void => {
                            searchRegistrar(value);
                        }}
                        onPressEnter={(e: any): void => {
                            searchRegistrar(e.target.value);
                        }}
                    />
                </div>
            );
        }
    //console.log('RenderSearch Passo da qui')
        return (
            <>{item}</>
        );
    }

    const getNameFromToken = (token: Keycloak): string => {
        let preferredName: string = '...';

        if (token && token.tokenParsed) {


            const tokenParsed: ExtendedTokenParsed = (token.tokenParsed) as ExtendedTokenParsed;

            preferredName = (tokenParsed.registrar) || '...';

        }
        return preferredName;
    }

    const renderUserMenu = (full: boolean): React.ReactElement<any> => {
        let preferredName: string|undefined = '...';
        if (keycloak && keycloak.tokenParsed) {

            const tokenParsed: ExtendedTokenParsed = (keycloak.tokenParsed) as ExtendedTokenParsed;

            preferredName = (tokenParsed.given_name || tokenParsed.preferred_username);
        }
/*
        const userMenu = (
            <Menu>
                <Menu.Item key="0">
                    <Flex
                        direction={'row'}
                        justify={'flex-start'}
                        align={'center'}
                        className="user-info spaces"
                        onClick={() => {keycloak.logout({redirectUri: `${window.location.origin}`}); }}
                    >
                    <span>
                        <i className={'fal fa-sign-out'}/>
                    </span>
                        <span className={'menu-left-space'}>
                        {t('header.logout')}
                    </span>
                    </Flex>
                </Menu.Item>
            </Menu>
        );
*/
        let dropDownComponent = (
            <span>
                    <i className="fal fa-user-circle"/>
                        <span className="spaces">{preferredName}</span>
                    <i className="fal fa-angle-down"/>
                </span>
        );

        const items: MenuProps['items'] = [
            {
                key: 'username',
                icon: <span>
                        <i className={'fal fa-sign-out'}/>
                    </span>,
                label: t('header.logout')
            }
        ]
        const onClick: MenuProps['onClick'] = ({key}) => {
            keycloak.logout({redirectUri: `${window.location.origin}`});
        };

        return (
            <Dropdown
                menu={{items, onClick}}
                placement={'bottomLeft'}>
                <div style={{cursor: 'pointer'}} onClick={(e) => {e.preventDefault()}}>
                    {dropDownComponent}
                </div>
            </Dropdown>
        );
    }

    const renderLanguageSwitch = () => {

        let isDefault: boolean = (locale === 'it');
        return (
            <div>

                <Switch
                    className={'language-switcher double-spaces'}
                    defaultChecked={isDefault}
                    checkedChildren={'ITA'}
                    unCheckedChildren={'ENG'}
                    onChange={() => {
                        const lang: string = (locale === 'it' ? 'en' : 'it');
                        updateLocale(lang);
                        moment.locale(locale === 'it' ? 'en': 'it')
                    }}
                />
            </div>
        );
    }

    const renderRegistryContacts = (): React.ReactElement<any> => {

            return (
<Can I={Actions.VIEW} an={Subjects.REGISTRAR_INFO}>
                <div style={{paddingRight: '10px', fontSize: '1.6rem', color: '#00a0fb'}}>
                    <Tooltip title={t('tooltip.registrar.info')}>
                        <StyledLink
                            cursor={'pointer'}
                            onClick={() => {
                                setOpenInfo(true);
                            }}
                        >
                            <i className={'fas fa-phone-square'}/>
                        </StyledLink>
                    </Tooltip>
                    <Modal
                        title={
                            <div style={{marginBottom: '0px'}}>
                            <span style={{marginRight: '10px'}}>
                                <img
                                    alt={'logo'}
                                    style={{
                                        height: '1.8rem'
                                    }}
                                    src={'/logoRegistroNew.svg'}
                                />
                            </span>
                                <span>
                                {t('info.title')}
                            </span>
                            </div>}
                        styles={{
                            body: {
                            paddingTop: '0px'
                        }}}
                        keyboard={true}
                        closable={false}
                        open={openInfo}
                        onCancel={() => {
                            setOpenInfo(false);
                        }}
                        footer={
                            <Button onClick={() => {
                                setOpenInfo(false);
                            }}>
                                {t('button.close')}
                            </Button>}
                    >

                        <RegistrarInfo
                            registrar={getNameFromToken(keycloak)}
                            enabled={openInfo}
                        />

                    </Modal>
                </div>
</Can>
            )

    }

    const renderMediumDisplayHeader = (): React.ReactElement<any> => {

    //console.log('rendermediumdisplay')
        let isRegistry: boolean = keycloak.realm === 'registry'

        if (!isRegistry) {
            return renderLargeDisplayHeader('3vw');
        } else {

            // let isDefault: boolean = (locale === 'it');
            let url = parse(location.pathname);
            let matchCalendar = matchPath('/bookings/calendar/:period/:year?/:month?/:day?', url.pathname);
            let matchRequest = matchPath('/requests', url.pathname);

            const today = moment();
            const week = today.week();
            const year = today.year();
            // let redirectUri = {redirectUri: url.origin};
            return (
                <Flex
                    direction={'row'}
                    wrap={'wrap'}
                    justify={'space-around'}
                    align={'center'}

                    style={{
                        width: '100vw',
                        backgroundColor: 'white',
                        borderBottom: '1px solid #e9e9e9'
                    }}
                >
                    <Drawer  getContainer={null} style={{left: 0}}>
                        <Flex
                            direction={'column'}
                            style={{
                                width: '40vw',
                                height: '100vh'
                            }}

                        >
                            <div>
                                <div style={{textAlign: 'center', marginTop: '4vh'}}>
                                    {renderLogo('6vw')}
                                </div>
                                {renderDocumentList('inline')}
                                {renderLanguageSwitch()}
                            </div>
                        </Flex>
                    </Drawer>
                    <Flex
                        direction={'row'}
                        wrap={'wrap'}
                        align={'center'}
                        style={{
                            height: '6vh',
                            width: '90%',
                            justifyContent: 'space-around',
                            backgroundColor: 'white',
                        }}

                    >
                        {renderLogo('2vw')}

                        {isRegistry &&

                        <Flex
                            direction={'row'}
                            wrap={'wrap'}
                            align={'center'}
                            justify={'space-around'}
                            style={{
                                flexGrow: 2,
                                height: '100%',
                            }}
                        >
                            {renderMenuItem('/requests', 'header.menu.Requests', matchRequest)}
                            <Can I={Actions.VIEW} an={Subjects.CALENDAR}>

                                { renderMenuItem(
                                        `/bookings/calendar/week/${year}/${week}`,
                                        'header.menu.Calendar', matchCalendar)}

                            </Can>
                            {renderSearch()}
                        </Flex>

                        }

                        <Flex
                            direction={'row'}
                            wrap={'wrap'}
                            align={'center'}
                            justify={'flex-end'}
                            style={{
                                flexGrow: 4,
                                height: '100%',
                            }}
                        >
                            <div style={{marginRight: '20px'}}>

                                {renderUserMenu(true)}

                            </div>
                        </Flex>
                    </Flex>
                </Flex>
            );
        }
    }

    const renderLargeDisplayHeader = (logoSize: string): React.ReactElement<any> => {
        //console.log('renderlargemdisplay')

        let isRegistry: boolean = (keycloak.realm === 'registry');

        let url = parse(location.pathname);
        let matchCalendar = matchPath('/bookings/calendar/:period/:year?/:month?/:day?', url.pathname);
        let matchRequest = matchPath('/requests', url.pathname);

        const today = moment();
        const week = today.week();
        const year = today.year();

        return (
            <Flex
                direction={'row'}
                align={'center'}
                wrap={'wrap'}
                justify={'space-around'}
                style={{
                    width: '100vw',
                    backgroundColor: 'white',
                    borderBottom: '1px solid #e9e9e9'

                }}
            >
                <Flex
                    direction={'row'}
                    wrap={'wrap'}
                    align={'center'}
                    justify={'space-between'}
                    style={{
                        height: '6vh',
                        width: '90%',
                        backgroundColor: 'white',
                    }}

                >

                    {renderLogo(logoSize)}

                    {isRegistry &&
                    <Flex
                        direction={'row'}
                        align={'center'}
                        wrap={'wrap'}
                        justify={'space-around'}
                        style={{
                            flexGrow: 2,
                            height: '100%',
                        }}
                    >
                        {renderMenuItem('/requests', 'header.menu.Requests', matchRequest)}
                        <Can I={Actions.VIEW} an={Subjects.CALENDAR}>
                            {
                                 renderMenuItem(
                                     `/bookings/calendar/week/${year}/${week}`,
                                     'header.menu.Calendar', matchCalendar)
                            }
                        </Can>
                        {renderDocumentMenu()}
                        {renderSearch()}
                    </Flex>
                    }

                    <Flex
                        direction={'row'}
                        wrap={'wrap'}
                        justify={'flex-end'}
                        style={{
                            flexGrow: 3,
                            height: '100%',
                        }}
                    >
                        <div >
                            {renderUserMenu(true)}
                        </div>
                        {renderLanguageSwitch()}
                        {!isRegistry && renderRegistryContacts()}
                    </Flex>
                </Flex>
            </Flex>
        );
    }

    const renderMenuItem = (path: string, label: string, match: any | undefined) => {

      //  console.log('RenderMenuItem: ', hasRole(keycloak, 'user'))

        let item = <></>;
        if (hasRole(keycloak, 'user')) {
            item = (
                <div
                    style={{
                        fontSize: '0.9rem',
                    }}
                >
                    <Link
                        to={path}
                        style={{color: (isNullOrUndefined(match) ? 'gray' : '#1890ff' ), textDecoration: 'none'}}
                    >
                        {t(label)}
                    </Link>
                </div>
            );
        }
        return (
            <>{item}</>
        );
    }

    const renderDocumentList = (mode: MenuMode) => {


        const docs = (window as any)[docConf];

        // console.log('Documents: ', docs);
        let g = 0;
        let menuGroups: Array<React.ReactElement<any>> = [];
        for (let doc in docs) {
            if (doc) {
                let currentDocConf = docs[doc];
                let base = currentDocConf[locale];
                let versions: Array<string> = currentDocConf.revisions;
                let menuItem: Array<React.ReactElement<any>> = [];
                versions.forEach((version, i) => {
                    menuItem.push(
                        <Menu.Item key={`document-${i}`}>
                            <Flex
                                direction={'row'}
                                justify={'flex-start'}
                                align={'center'}
                                className="user-info spaces"
                                onClick={() => {
                                    setShowDocuments(true)
                                    setTestType(doc)
                                    setTestVersion(version)
                                }}
                            >
                                <DocumentIcon color={'#cccccc'} size={'1rem'}/>
                                <span className={'menu-left-space'}>
                                    {`${base} ${version}`}
                                </span>
                            </Flex>
                        </Menu.Item>
                    );
                });
                menuGroups.push(
                    <Menu.ItemGroup key={`${g++}`} title={t(`menu.accreditation.${doc}`)}>
                        {menuItem}
                    </Menu.ItemGroup>
                );
            }
        }

        const documentMenu  = (
            <Menu mode={mode} onSelect={() => {setOpenMenu(false) }}>
                <Menu.SubMenu key={'documents'} title={t('header.menu.Documents')}>
                    {menuGroups}
                </Menu.SubMenu>
            </Menu>
        );

        return documentMenu;
    }

    const renderDocumentMenu = () => {

        const docs = (window as any)[docConf];

        // console.log('Documents: ', docs);

        let g = 0;
        let menuGroups: Array<React.ReactElement<any>> = [];
        for (let doc in docs) {
            if (doc) {
                let currentDocConf = docs[doc];
                let base = currentDocConf[locale];
                let versions: Array<string> = currentDocConf.revisions;
                let menuItem: Array<React.ReactElement<any>> = [];
                versions.forEach((version, i) => {
                    menuItem.push(
                        <Menu.Item key={`${i}`}>
                            <Flex
                                direction={'row'}
                                justify={'flex-start'}
                                align={'center'}
                                className="user-info spaces"
                                onClick={() => {
                                    setShowDocuments(true)
                                    setTestType(doc)
                                    setTestVersion(version)
                                }}
                            >
                                <DocumentIcon color={'#cccccc'} size={'1rem'}/>
                                <span className={'menu-left-space'}>
                                    {`${base} ${version}`}
                                </span>
                            </Flex>
                        </Menu.Item>
                    );
                });
                menuGroups.push(
                    <Menu.SubMenu
                        key={`${g++}`}
                        title={t(`menu.accreditation.${doc}`)}
                    >
                        {menuItem}
                    </Menu.SubMenu>
                );
            }
        }
/*
        const documentMenu = (
            <Menu>
                {menuGroups}
            </Menu>
        );
*/
        const docTable: Record<string, string> = {}
        const verTable: Record<string, string> = {}

        const buildDocumentMenu = () => {
            const items: any[] = []
            for (let doc in docs) {
                if (doc) {
                    const currentDocConf = docs[doc];
                    const base = currentDocConf[locale];
                    const versions: Array<string> = currentDocConf.revisions;
                    const sub = versions.map((version, key) => {

                        docTable[`${doc}-${key}`] = doc
                        verTable[`${doc}-${key}`] = version

                        return ({
                            key: `${doc}-${key}`,
                            icon:  <DocumentIcon color={'#cccccc'} size={'1rem'}/>,
                            label: `${base} ${version}`
                        })
                    })
                    items.push({
                        key: doc,
                        label: t(`menu.accreditation.${doc}`),
                        children: sub
                    })
                }

            }
            return items
        }

        const items: MenuProps['items'] = buildDocumentMenu()
        const onClick: MenuProps['onClick'] = ({key}) => {

            setShowDocuments(true)
            setTestType(docTable[key])
            setTestVersion(verTable[key])


        };

        return (
            <Dropdown
                menu={{items, onClick}}>
                <div style={{color: '#808488', fontSize: '0.9rem', cursor: 'pointer'}}>
                    <span
                        className="spaces"
                    >
                        {t('header.menu.Documents')}
                    </span>
                </div>
            </Dropdown>
        );
    }
        let modal = null;
        if (showDocuments) {
            modal = renderDocumentModal();
        }

        return (
            <div>
                {modal}
                <MediaQuery minWidth={1224}>
                    {renderLargeDisplayHeader('2vw')}
                </MediaQuery>

                <MediaQuery minWidth={850} maxWidth={1224}>
                    {renderMediumDisplayHeader()}
                </MediaQuery>

                <MediaQuery minWidth={300} maxWidth={849}>
                    {renderSmallDisplayHeader()}
                </MediaQuery>
            </div>
        );

}

export default Header